// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Milkyway Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const MilkyWayAliensPlanets = {
  // Planet-specific alien populations
  planets: {
    // SOL (0) - Earth, home base
    0: ['vulcans', 'ferengi', 'andorians'],
    
    // KEPLER-442 (1) - Distant super-Earth
    1: ['crystalline', 'aquatic'],
    
    // PROXIMA CENTAURI (2) - Closest neighbor
    2: ['vulcans', 'andorians'],
    
    // WOLF 359 (3) - Borg encounter site
    3: ['borg', 'greys'],
    
    // GLIESE 667C (4) - Resource-rich
    4: ['klingons', 'ferengi'],
    
    // TRAPPIST-1 (5) - Seven planet system
    5: ['vulcans', 'andorians', 'aquatic'],
    
    // BARNARD'S STAR (6) - Mining outposts
    6: ['ferengi', 'crystalline'],
    
    // LUYTEN'S STAR (7) - Biosignatures
    7: ['vulcans', 'aquatic', 'greys'],
    
    // ROSS 154 (8) - Automated mining
    8: ['crystalline', 'hivemind'],
    
    // 51 PEGASI (9) - Gas mining
    9: ['gaseous', 'photonic'],
    
    // COR CAROLI (10) - Waystation
    10: ['vulcans', 'ferengi'],
    
    // SIRIUS (36) - Technology hub
    36: ['vulcans', 'andorians', 'ferengi'],
    
    // PROCYON (37) - Trading post
    37: ['ferengi', 'vulcans'],
    
    // EPSILON ERIDANI (38) - Colonization
    38: ['vulcans', 'aquatic'],
    
    // TAU CETI (39) - Earth analog
    39: ['vulcans', 'andorians', 'aquatic']
  },
  
  // Random encounter aliens
  randomEncounters: [
    'vulcans',
    'klingons',
    'ferengi',
    'andorians',
    'greys',
    'crystalline'
  ],
  
  // Hostile aliens
  hostileSpecies: [
    'borg',
    'klingons' // Can be hostile or friendly depending on context
  ],
  
  // Friendly traders
  friendlyTraders: [
    'ferengi',
    'vulcans',
    'andorians',
    'crystalline',
    'aquatic'
  ]
};

export default MilkyWayAliensPlanets;
